"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondaryButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
/**
 * Secondary button component.
 * Native HTML button element is used.
 */
exports.SecondaryButton = styled_components_1.default.button `
  padding: 11px 15px; // -1px to fix 1px border
  margin: 0;
  width: 224px;

  background: transparent;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.designSystem.accent};

  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  text-transform: uppercase;
  text-align: center;

  color: ${({ theme }) => theme.designSystem.accent};

  cursor: pointer;
`;
